import { GET_CountriesCities_FAILD, GET_CountriesCities_LOADING, GET_CountriesCities_RESET, GET_CountriesCities_SUCCESS } from "../types";

const initialState = {
  loading: false,
  error: null,
  Countries: null,
};

export const getCountriesCitiesReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_CountriesCities_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_CountriesCities_SUCCESS:
      return {
        ...state,
        loading: false,
        Countries: action.payload,
        error: null,
      };
    case GET_CountriesCities_FAILD:
      return {
        ...state,
        loading: false,
        Countries: null,
        error: action.error,
      };
    case GET_CountriesCities_RESET:
      return initialState;
    default:
      return state;
  }
};
